/***
 *
 *   TOOLTIP STYLES
 *   Ported from ui-reference/src/components/ui/tooltip.tsx.
 *
 **********/

const Style = {
    wrapper: 'relative inline-flex',
    content: 'pointer-events-none absolute z-50 w-max overflow-hidden rounded-md bg-primary-900 px-3 py-1.5 text-xs text-white shadow-md animate-fade-in',

    // sideOffset 6, matching the reference's default
    top: 'bottom-full left-1/2 mb-1.5 -translate-x-1/2',
    bottom: 'top-full left-1/2 mt-1.5 -translate-x-1/2',
    left: 'right-full top-1/2 mr-1.5 -translate-y-1/2',
    right: 'left-full top-1/2 ml-1.5 -translate-y-1/2',
};

export default Style;
